require('../img/email/banner.jpg');
require('../img/email/side.jpg');
require('../img/email/social/facebook.jpg');
require('../img/email/social/instagram.jpg');
require('../img/email/social/linkedin.jpg');
require('../img/email/social/twitter.jpg');
require('../img/icons/logo-light.png');
require('../img/watermark-testimonials-dark.png');
